// @flow
import * as React from 'react';
import styled from 'styled-components';
import { display } from 'styled-system';
import { transition, colors } from '../theme';

const { useState, useRef } = React;

const Tooltip = styled(({ display: displayProp, left, top, ...props }) => (
  <div {...props} />
)).attrs(({ left, top }) => ({
  style: {
    left,
    top
  }
}))`
  position: fixed;
  z-index: 9999;
  transform: translate3d(-50%, 3px, 0);
  padding: 2px 6px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  opacity: 0;
  color: ${colors.battleshipGrey};
  visibility: hidden;
  font-size: 12px;
  transition: all ${transition};
  transition-property: opacity, transform, visibility;
  ${display};
`;

const Container = styled.div`
  text-align: left;
  &:hover,
  &:focus,
  &:focus-within {
    ${Tooltip} {
      transform: translate3d(-50%, 0, 0);
      opacity: 1;
      visibility: visible;
    }
  }
`;

const SimpleTooltip = ({
  text,
  offsetBottom,
  disabled,
  children,
  xs,
  sm,
  md,
  lg,
  xl
}: {
  text: React.Node,
  offsetBottom?: number,
  disabled?: boolean,
  children: React.Node,
  xs?: boolean,
  sm?: boolean,
  md?: boolean,
  lg?: boolean,
  xl?: boolean
}) => {
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);

  const ref = useRef(null);

  const update = () => {
    if (ref && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setTop(rect.top + rect.height + (offsetBottom || 0));
      setLeft(rect.left + rect.width / 2);
    }
  };

  return (
    <Container ref={ref} onMouseOver={update} onFocus={update}>
      {children}
      {!disabled && (
        <Tooltip
          display={[xs, sm, md, lg, xl].map(n => (n ? 'none' : 'block'))}
          left={left}
          top={top}
        >
          {text}
        </Tooltip>
      )}
    </Container>
  );
};

export default SimpleTooltip;
